package koala.html

import kotlinx.html.*
import koala.css.*

fun FlowContent.row(
    id: Id,
    modifiers: ModifierSet? = null,
    block: DIV.() -> Unit = {},
) {
    row(modifiers) {
        this.id = id.identifier
        block()
    }
}

fun FlowContent.row(
    modifiers: ModifierSet? = null,
    block: DIV.() -> Unit = {},
) {
    div {
        addModifiers(Row, modifiers)
        block()
    }
}